import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box, Text } from '@chakra-ui/react';
import FieldToolTip from '@/components/forms/new/FieldToolTip';
import { Field } from 'formik';
import DropDown from '@/components/forms/new/formikFormFields/DropDown';
import {
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from '@/components/forms/new/formStyles';
import walkthroughIds from '../../walkthroughIds';

const OutboundCallerIDDropdown = ({
    data,
    setCurrentNumber,
    errors,
    touched,
    darkMode,
    outboundCallerIDs,
}) => {
    const handleSelectChange = (item) => {
        setCurrentNumber((prev) => ({
            ...prev,
            cliPresentation: item.telephoneNumber,
        }));
    };

    const [isHovered, setIsHovered] = useState(false);
    const fieldName = 'formValues[0].outboundCallerId';

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={errors?.outboundCallerId && touched?.outboundCallerId}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                sx={{ ...stackStyling(true), width: '740px' }}>
                <Box width={190}>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Outbound Caller ID
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Choose an available TCAP number to show as alternative
                        Caller ID
                    </Text>
                </Box>
                <Field
                    component={DropDown}
                    id={fieldName}
                    name={fieldName}
                    shownValue="telephoneNumber"
                    selectedId="telephoneNumber"
                    currentId={data?.cliPresentation}
                    isPhoneNumber={true}
                    handleSelectChange={handleSelectChange}
                    darkMode={darkMode}
                    data={outboundCallerIDs}
                    data-walkthroughid={
                        walkthroughIds.editNumbersGeneral.editPlatformNumbers
                    }
                />
                {isHovered && (
                    <FieldToolTip
                        label="Choose an available TCAP number to show as alternative Caller ID"
                        ariaLabel="numbers-outbound-caller-id-dropdown-tooltip"
                        right="25px"
                        top="23px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default OutboundCallerIDDropdown;
